import React from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import VerifiedBar from "@/components/landing/VerifiedBar";
import HowItWorks from "@/components/landing/HowItWorks";
import Benefits from "@/components/landing/Benefits";
import Pricing from "@/components/landing/Pricing";
import Sharia from "@/components/landing/Sharia";
import Testimonials from "@/components/landing/Testimonials";
import TransferProofs from "@/components/landing/TransferProofs";
import ContactSection from "@/components/landing/ContactSection";
import Footer from "@/components/landing/Footer";
import StickyWhatsApp from "@/components/landing/StickyWhatsApp";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-brand-bg text-brand-ink font-body" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <VerifiedBar />
        <HowItWorks />
        <Benefits />
        <Pricing />
        <Sharia />
        <TransferProofs />
        <Testimonials />
        <ContactSection />
      </main>
      <Footer />
      <StickyWhatsApp />
    </div>
  );
}
